import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { selectProfileById } from '../store/slice'
import { deleteAlertProfile, getAlertSettingsDynamic } from '../store/thunk'

export const DeleteCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const profile = useSelector(selectProfileById(rowId))
  const isDisabled = useSelector(selectProfileById(rowId, 'disabled'))

  const [isShow, setIsShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleOpen = (e) => {
    e?.stopPropagation()
    setIsShow(true)
  }

  const handleClose = (e) => {
    e?.stopPropagation()
    if (isLoading) return
    setIsShow(false)
  }

  const handleDelete = (e) => {
    e?.stopPropagation()
    if (isLoading) return

    setIsLoading(true)

    dispatch(deleteAlertProfile({ alertProfileIds: [rowId] }))
      .then(() => {
        dispatch(getAlertSettingsDynamic())
      })
      .finally(() => {
        setIsLoading(false)
        handleClose()
      })
  }

  if (profile.isDefaultProfile || isDisabled) return null

  return (
    <>
      <Icon
        className="icon-trash-fill"
        style={{ fontSize: 15, color: '#9C9C9C' }}
        onClick={handleOpen}
      />
      <PopupAction
        isShow={isShow}
        title="alertSetting.DELETE_PROFILE_TITLE"
        btnCancel={{
          label: 'common.CANCEL',
          isI18n: true,
          event: handleClose,
          disabled: isLoading,
        }}
        btnSubmit={{
          label: 'common.DELETE',
          isI18n: true,
          event: handleDelete,
          disabled: isLoading,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate
              value="alertSetting.DELETE_PROFILE_MESS"
              name={profile.profileName}
            />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
